import { useAuthContext, usePermissions } from '/src/hooks';
import { UpsellWall } from '/src/components/UpsellWall';
import { WebP } from '/src/components/WebP';
import { FEATURES } from '/src/features/_global/constants';

import FeaturedImagePNG from '@crazyegginc/hatch/dist/images/illustration-upsell-traffic.png';
import FeaturedImageWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-traffic.webp';
import LeftPeoplePhotoPNG from '@crazyegginc/hatch/dist/images/people-lukasz-s.png';
import RightPeoplePhotoPNG from '@crazyegginc/hatch/dist/images/people-andrew-m.png';

import CapterraWebP from '@crazyegginc/hatch/dist/images/logo-capterra.webp';
import CapterraPNG from '@crazyegginc/hatch/dist/images/logo-capterra.png';

const TEXT_LIST = [
  {
    text: 'Instantly spot which referrals are driving traffic',
  },
  {
    text: 'Optimize campaign spend before budget goes to waste',
  },
  {
    text: 'Compare landing pages to uncover patterns and boost conversions',
  },
];

const TextContent = ({ canManageBilling, ownerEmail, isStripeUser }) => {
  return (
    <>
      <UpsellWall.Title
        titleText={
          canManageBilling ? 'Pinpoint what works in your marketing' : 'Request an upgrade to the Starter plan'
        }
        subtitleText={!canManageBilling ? 'Analyze website traffic based on where your visitors come from.' : null}
      />

      {canManageBilling ? (
        <UpsellWall.List list={TEXT_LIST} noTextBelow={true} />
      ) : (
        <>
          <p className="mb-6 text-black-pearl-500 text-sm">
            Contact your Account Admin at <strong>{ownerEmail}</strong> to upgrade and access Traffic Analysis.
          </p>
        </>
      )}
      <UpsellWall.CTA
        metricType="traffic_analysis_upsell_paywall"
        canManageBilling={canManageBilling}
        ownerEmail={ownerEmail}
        isStripeUser={isStripeUser}
      />
    </>
  );
};

const LeftContent = () => {
  return (
    <div className="flex">
      <WebP webp={CapterraWebP} fallback={CapterraPNG} width="80" height="80" alt="capterra" className="mr-10" />
      <div className="flex-1">
        <UpsellWall.TestimonialText textClassNames="mb-10">
          If you are interested in the flow of users through your site, then the traffic analysis tools included in
          Crazy Egg are the most advanced and complex on the market.
        </UpsellWall.TestimonialText>
        <UpsellWall.TestimonialPerson
          name="Lukasz S., Verified Capterra Reviewer"
          title="Freelance Marketing Consultant"
          imagePNG={LeftPeoplePhotoPNG}
          imageWidth="40"
          imageHeight="40"
        />
      </div>
    </div>
  );
};

const RightContent = () => {
  return (
    <>
      <UpsellWall.TestimonialText textClassNames="mb-10">
        Bottom line Crazy Egg allows you to make informed decisions to increase conversion and enhance the user
        experience on your website.
      </UpsellWall.TestimonialText>
      <UpsellWall.TestimonialPerson
        name="Andrew M., Verified Capterra Reviewer"
        title="Marketing Technologist"
        imagePNG={RightPeoplePhotoPNG}
        imageWidth="40"
        imageHeight="40"
      />
    </>
  );
};

export function TAUpsellPaywall() {
  const { currentAccount } = useAuthContext();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <UpsellWall>
      <UpsellWall.TopPanel
        textContent={
          <TextContent
            canManageBilling={canManageBilling}
            ownerEmail={currentAccount.ownerEmail}
            isStripeUser={isStripeUser}
          />
        }
        imagePNG={FeaturedImagePNG}
        imageWebP={FeaturedImageWebP}
        imageWidth="512"
        imageHeight="256"
        imageAlt="traffic analysis feature"
      />
      <UpsellWall.BottomPanel isSeparate={false} leftContent={<LeftContent />} rightContent={<RightContent />} />
    </UpsellWall>
  );
}
